import { render, staticRenderFns } from "./RefsRepairEstimate.vue?vue&type=template&id=b87af6d0"
import script from "./RefsRepairEstimate.vue?vue&type=script&lang=ts"
export * from "./RefsRepairEstimate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports